"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMCQComponentParameters = void 0;
exports.UserMCQComponentParameters = [
    {
        id: 'options',
        label: 'MCQ Options',
        description: 'Input Param - List of options from which the user needs to select the correct ones',
        type: 'list',
        paramType: 'STRING_ARRAY',
        required: true,
    },
    {
        id: 'min',
        label: 'Min Selected Options',
        description: 'Input Param - Minimum number of options to be selected by the user',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max',
        label: 'Max Selected Options',
        description: 'Input Param - Maximum number of options to be selected by the user',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'type',
        label: 'Type',
        description: 'Input Param - Layout type of the MCQ (VERTICAL, HORIZONTAL, WORD_CLOUD)',
        type: 'enum',
        list: {
            VERTICAL: 'Vertical',
            HORIZONTAL: 'Horizontal',
            WORD_CLOUD: 'Word Cloud',
        },
        paramType: 'ENUM',
        required: false,
    },
    {
        id: 'enableOther',
        label: 'Enable Other',
        description: 'Input Param - Enable Other option for the MCQ',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'selected',
        label: 'Options Selected By User',
        description: 'Output Param - List of options from which the user needs to select the correct ones',
        type: 'output',
        paramType: 'STRING_ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserMCQComponent.js.map